import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {PortalStep, PathHistory} from './Enum';
import {GetOrgUserDetails, setCurrentStep, setEpiContent, setShowPopUp, saveToHistory} from './OrganizationPortalSlice';
import OrganizationOtp from './OrganizationOtp';
import OrgPlanSelection from './OrgPlanSelection';
import OrganizationMsgPopup from './PopUp/OrganizationMsgPopup';
import Popup from '../../Shared/Popup/PopUp';
import UserPersonalInfo from './UserPersonalInfo';
import UserPaymentInfo from './UserPaymentInfo';
import StepBar from '../../Shared/StepBar/StepBar';
import DistributionCenter from './DistributionCenter';
import OrgProductSelection from './OrgProductSelection';
import OrgOrderSummary from './OrgOrderSummary';
import SelectNumOfPayment from './SelectNumOfPayment';

function OrganizationPortalMain(props) {
  const userActionType = props.userDetails.actionType;
  const {isFullAuthenticated} = props.authentication?.loginData || {};
  const loginUserDetails = props.authentication?.loginData?.userDetails;
  const userId = loginUserDetails?.IDNumber;
  const phoneNumber = loginUserDetails?.contactNumber;
  const hasLoadedOrgUser = props.orgDetails.orgPlans?.length > 0;
  const stepsList = userActionType === 'activate'
    ? props.stepsList
    : props.stepsList.filter((step) => step !== PortalStep.UserPersonalInfo);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [props.currentStep]);
  useEffect(() => {
    if (props.currentStep === PortalStep.UserPersonalInfo && userActionType !== 'activate') {
      props.setCurrentStep({current: PortalStep.UserPaymentInfo, previous: PortalStep.UserPersonalInfo});
    }
  }, [props.currentStep, userActionType]);
  useEffect(() => {
    const canAutoLogin =
      props.currentStep === PortalStep.OtpVerifyPhonePage && isFullAuthenticated && userId && phoneNumber && !hasLoadedOrgUser;

    if (!canAutoLogin) {
      return;
    }

    props.GetOrgUserDetails({
      phoneNumber,
      userId,
    });
  }, [
    props.currentStep,
    isFullAuthenticated,
    userId,
    phoneNumber,
    hasLoadedOrgUser,
  ]);
  let currentStep = () => {
    switch (props.currentStep) {
      case PortalStep.OtpVerifyPhonePage:
        if (isFullAuthenticated) {
          return null;
        }
        props.saveToHistory(PathHistory.login);
        return <OrganizationOtp />;

      case PortalStep.PlanSelection:
        props.saveToHistory(PathHistory.PlanSelection);
        return <OrgPlanSelection />;

      case PortalStep.ProductSelection:
        props.saveToHistory(PathHistory.ProductSelection);
        return <OrgProductSelection />;

      case PortalStep.UserPersonalInfo:
        if (userActionType === 'activate') {
          props.saveToHistory(PathHistory.PersonalInfo);
          return <UserPersonalInfo />;
        } else {
          return null;
        }
      case PortalStep.UserPaymentInfo:
        props.saveToHistory(PathHistory.PaymentInfo);
        if (props.userDetails?.ban != '' || userActionType !== 'activate') {
          return <SelectNumOfPayment />;
        } else {
          return <UserPaymentInfo />;
        }

      case PortalStep.DistributionCenter:
        props.saveToHistory(PathHistory.DistributionCenter);
        return <DistributionCenter />;

      case PortalStep.OrderSummary:
        props.saveToHistory(PathHistory.OrderSummary);
        return <OrgOrderSummary />;
    }
  };

  return (
    <div className='OrganizationPortal'>
      {stepsList.includes(props.currentStep) && <StepBar currentStep={props.currentStep} steps={stepsList} />}
      {currentStep()}
      <Popup className='OrganizationPopup' showPopUp={props.showPopup} onClose={() => props.setShowPopUp(false)}>
        <OrganizationMsgPopup />
      </Popup>
    </div>
  );
}

const mapStateToProps = (state) => ({
  currentStep: state.organizationPortal.steps.current,
  userDetails: state.organizationPortal.userDetails,
  showPopup: state.organizationPortal.showPopup,
  messageContent: state.organizationPortal.messageContent,
  orgDetails: state.organizationPortal.orgDetails,
  stepsList: state.organizationPortal.stepsList,
  authentication: state.authentication,
});

const mapDispatchToProps = {
  setCurrentStep,
  GetOrgUserDetails,
  setEpiContent,
  setShowPopUp,
  saveToHistory,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationPortalMain);
